<div class="d-inline-flex">
  <ncp-select
    #select
    class="d-inline-flex text-nowrap align-items-baseline"
    [(options)]="unknownSelectOptions"
  />
</div>
